<template>
  <v-row v-if="ready" class="login-kpi">
    <v-col
      v-for="item in items"
      :key="item.key"
      cols="6"
      sm="4"
      md="2"
    >
      <dynamics-indicator-item
        :title="item.title"
        :tooltip-text="item.tooltip"
        :icon="item.icon"
        value-type="count"
        :indicator-data="item.data"
        :increasing-status-color="item.up"
        :decreasing-status-color="item.down"
        :loading="loading"
      />
    </v-col>
  </v-row>
</template>

<script>
  import DynamicsIndicatorItem from '@/components/stat/revenue/DynamicsIndicatorItem.vue'

  const GREEN = '#6BAD01'
  const RED = '#E92663'

  export default {
    name: 'LoginIndicatorsList',
    components: { DynamicsIndicatorItem },
    props: {
      indicators: { type: Object, default: () => ({}) },
      loading: { type: Boolean, default: false },
    },
    computed: {
      ready () {
        const i = this.indicators
        return !!(i && i.codesSent && i.smsCount && i.flashCount &&
          i.loginsCount && i.blockedCount && i.loginRate)
      },
      items () {
        if (!this.ready) return []
        const i = this.indicators
        // up/down — цвета роста/падения. Для «плохих» метрик (рост = хуже) инвертируем.
        const good = { up: GREEN, down: RED }
        const bad = { up: RED, down: GREEN }
        return [
          { key: 'codes', title: 'Отправлено кодов', tooltip: 'Всего отправок кода за период', icon: '/img/stat/icons/orders.svg', data: i.codesSent, ...good },
          { key: 'sms', title: 'SMS (платных)', tooltip: 'Кодов доставлено по SMS — это деньги', icon: '/img/stat/icons/headset-solid.svg', data: i.smsCount, ...good },
          { key: 'flash', title: 'Flash-call', tooltip: 'Кодов доставлено flash-звонком', icon: '/img/stat/icons/service.svg', data: i.flashCount, ...good },
          { key: 'logins', title: 'Логинов', tooltip: 'Успешных входов за период', icon: '/img/stat/icons/clients.svg', data: i.loginsCount, ...good },
          { key: 'blocked', title: 'Заблокировано', tooltip: 'Запросов отбито «реальным» блоком', icon: '/img/stat/icons/lost-clients.svg', data: i.blockedCount, ...bad },
          { key: 'rate', title: 'Login rate', tooltip: 'Отправлено / логины. Выше = хуже (сигнал атаки)', icon: '/img/stat/icons/final-rating.svg', data: i.loginRate, ...bad },
        ]
      },
    },
  }
</script>

<style lang="less" scoped>
.login-kpi {
  margin-bottom: 4px;
}
</style>
